import React from 'react';
import { CALL_STATUS } from '../callModel';

/** A call's outcome as a coloured badge (Answered, Missed, Voicemail…). */
export const CallStatus = ({ status }) => <span className={`status ${(CALL_STATUS[status] || [])[1] || ''}`}>{(CALL_STATUS[status] || [status])[0]}</span>;

/** Banner explaining why calling is unavailable, or null when it works. */
export function CallingBanner({ status }) {
  if (!status) return null;
  if (!status.configured) return <div className="preview-banner"><b>Not connected</b> Calling isn't connected yet. The TeleCalX administrator needs to connect the phone service (Plivo).</div>;
  if (status.numbers.length === 0) return <div className="preview-banner"><b>No number</b> Your company doesn't have a phone number yet. Ask TeleCalX support to assign one.</div>;
  return null;
}
